export const SITE_URL = 'https://www.apexbreath.com';
export const BRAND_NAME = 'Apex Breath';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/apex_breath_og_image.jpeg`;
export const ORGANIZATION_ID = `${SITE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_URL}/#website`;
export const TWITTER_HANDLE = '@ApexBreath';

export function absoluteUrl(path = '/') {
  if (!path || path === '/') return SITE_URL;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}
